import React from "react";
import {Typography} from "antd";

interface Props {
    searchResult: number
}

const TotalResult = ({searchResult}: Props) => {
    return (
        <Typography.Paragraph 
            style={{color: 'rgba(0, 0, 0, 0.5)', fontSize: '0.8em', margin:'2 em'}}
        >
            {`${searchResult} ${searchResult  > 1 ? 'results' : 'result'} found.`}
        </Typography.Paragraph>
    )
}

export default TotalResult;